import axios from "@/plugins/axios";

import * as auth from "./auth";
import * as console from "./console";
import * as v1 from "./v1";
import * as editor from "./editor";
import * as plugins from "./plugins";
import * as integratedViewer from "./integrated-viewer";
import deviceInfo from "./device-info"
// export { kakao } from "./kakao";
// export { naver } from "./naver";

export default {
    ...auth,
    ...console,
    ...v1,
    ...editor,
    ...plugins,
    ...integratedViewer,
    deviceInfo,

    getResource(filename){
        return axios({
            url: filename,
            method: 'GET',
            responseType: 'blob'
        }).then(result => {
                try{
                    return new File([result.data], filename.split('/').pop());
                }
                catch(error){
                    var blob = new Blob([result.data]);
                    blob.name = filename.split('/').pop();
                    return blob;
                }
            }
        );
    },
}
